<template>
  <section>
    <div class="row">
      <div class="col title">Submitting Revisions</div>
      <!--Mobile Only-->
      <div class="col-3 pl-1 hidden-md-up">
        <for-authors-mobile-menu :anchors-list="anchorsList"></for-authors-mobile-menu>
      </div>
      <!--Mobile Only-->
    </div>
    <div>
      <p>
        If you have been asked to revise your manuscript and you are ready to resubmit it, log on to the submission system and, on your author home page,
        click the "Revise Manuscript" link of the manuscript you wish to resubmit. You will be asked to review the information you originally submitted to confirm its accuracy.
        If any of the original files have been revised, replace them. Include only the final version of each file in your revision submission.
      </p>
      <p>
        In your rebuttal letter, please be sure to provide a point-by-point reply to the reviewers' comments as well as a
        listing of all the changes made, including any changes to authorship, noting the page numbers on which the individual
        changes appear. When you have successfully resubmitted your manuscript, you will receive acknowledgment via email.
        The revised version of your manuscript may undergo another review if the original submission required extensive changes
        or if the authors' responses to the criticisms entail rebuttal rather than revision. A decision as to whether or not the manuscript
        will be sent back out for review is made at the discretion of the Editors.
      </p>
    </div>
  </section>
</template>

<script>
  import ForAuthorsMobileMenu from '@/components/for-authors/ForAuthorsPageMobileMenu'
  export default {
    name: 'for-authors-revisions-submission-content',
    components: {ForAuthorsMobileMenu},
    props: ['anchorsList'],
    data () {
      return {
        siteName: process.env.SITE_NAME
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ForAuthorsRevisionsSubmissiomContent.vue?24d9757d